import { getPoseById } from '../poses/library'
import { useAppStore } from '../store'

export function Timeline() {
  const poseId = useAppStore((s) => s.poseId)
  const playing = useAppStore((s) => s.playing)
  const speed = useAppStore((s) => s.speed)
  const holdPose = useAppStore((s) => s.holdPose)
  const elapsedMs = useAppStore((s) => s.elapsedMs)
  const phase = useAppStore((s) => s.phase)
  const locked = useAppStore((s) => s.controlsLocked)
  const setPlaying = useAppStore((s) => s.setPlaying)
  const setSpeed = useAppStore((s) => s.setSpeed)
  const setHoldPose = useAppStore((s) => s.setHoldPose)
  const setElapsedMs = useAppStore((s) => s.setElapsedMs)
  const restart = useAppStore((s) => s.restart)

  const pose = getPoseById(poseId)
  const totalSec = pose
    ? (pose.timing.entry + pose.timing.hold + pose.timing.release) / Math.max(speed, 0.05)
    : 12
  const t = (elapsedMs / 1000) % totalSec
  const pct = (t / totalSec) * 100

  return (
    <div className="timeline">
      <div className="timeline-controls">
        <button type="button" disabled={locked} onClick={() => setPlaying(!playing)}>
          {playing ? 'Pause' : 'Play'}
        </button>
        <button type="button" disabled={locked} onClick={() => restart()}>Restart</button>
        <button
          type="button"
          className={holdPose ? 'active-toggle' : ''}
          disabled={locked}
          onClick={() => setHoldPose(!holdPose)}
        >
          Hold pose
        </button>
        <label className="speed">
          Speed
          <input
            type="range" min={0.25} max={2} step={0.25} value={speed} disabled={locked}
            onChange={(e) => setSpeed(Number(e.target.value))}
          />
          <span>{speed.toFixed(2)}×</span>
        </label>
        <span className="phase-pill">{phase}</span>
      </div>
      <input
        className="scrub"
        type="range"
        min={0}
        max={1000}
        value={Math.round((t / totalSec) * 1000)}
        disabled={locked || holdPose}
        onChange={(e) => {
          setElapsedMs((Number(e.target.value) / 1000) * totalSec * 1000)
          setPlaying(false)
        }}
      />
      <div className="timeline-track" aria-hidden>
        <div className="fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  )
}
